import { render, staticRenderFns } from "./OfertaSingle.vue?vue&type=template&id=9fdc2dce&"
import script from "./OfertaSingle.vue?vue&type=script&lang=js&"
export * from "./OfertaSingle.vue?vue&type=script&lang=js&"
import style0 from "./OfertaSingle.vue?vue&type=style&index=0&id=9fdc2dce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports